import React from 'react';
const ArrowTopThin = () => (
  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path d="M526.54316667 855.50950001" />
    <path d="M75.52616667 738.67600001c12.3165 12.3165 31.374 13.041 43.092 2.016L489.24716667 370.09450001c15.0885-15.9075 19.02599999-15.8445 34.8705-1e-8L894.68366667 740.69200001c11.6865 11.0565 30.77549999 10.3005 43.092-2.016 12.537-12.537 13.23-32.0985 1.6065-43.7535L527.74016667 283.249C522.66866666 278.1775 516.05366667 275.90950001 509.24966667 275.50000001l-5.166 1e-8c-6.8355 0.441-13.419 2.709-18.4905 7.74899999l-411.64200001 411.642C62.32766667 706.57750001 63.02066667 726.1705 75.52616667 738.67600001z" />
  </svg>
);
export default ArrowTopThin;
